<div [hidden]="tabbingService.visibleTab !== tab && !forceVisible" style="width: 100%; height: 100%; padding-left: 50px;">
  <p-skeleton *ngIf="showSkeleton" styleClass="p-mt-2" width="100%" height="100%"></p-skeleton>
  <ng-container #vc></ng-container>
</div>
